import React from "react";
import * as aor from "react-admin";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Done from "@material-ui/icons/Done";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import authClient, {
    setUserCompany,
    getUserCompanies,
    getLoggedUserFromToken,
    getPermissionsForLoggedUser,
    setLoggedUserIdFromToken,
    setLoginData
} from "../common/authClient";
import TranslatedText from "./TranslatedText";
import history from "../common/history";

class SelectCompany extends React.Component {
    state = { companies: null, selected_company: null };

    getCompanyComponents() {
        if (this.state.companies) {
            return this.state.companies.map(company => (
                <FormControlLabel
                    key={company.id}
                    value={company.id.toString()}
                    control={<Radio />}
                    label={company.name}
                />
            ));
        }
    }

    async saveCompany() {
        await setUserCompany(this.state.selected_company);
        await getPermissionsForLoggedUser();
        // sett user id in session
        await setLoggedUserIdFromToken();
        window.location.reload();
    }

    updateSelectedCompany(company_id) {
        this.setState({ selected_company: company_id.toString() });
    }

    handleChange(event) {
        this.updateSelectedCompany(event.target.value);
    }

    componentDidMount() {
        let companies = null;
        let logged_user = null;
        let username = null;
        // Estrai la query string dall'URL completo
        const fullUrl = window.location.href;
        const queryString = fullUrl.split("?")[1];
        const urlParams = new URLSearchParams(queryString);

        // Controlla se "companies" è presente nei parametri URL
        if (urlParams.has("companies")) {
            try {
                companies = JSON.parse(urlParams.get("companies"));
                username = urlParams.get("username");
                logged_user = decodeURIComponent(username);
                setLoginData(logged_user, companies);
            } catch (error) {
                console.error("JSON parsing failed for companies:", error);
                companies = null;
            }
        } else {
            companies = getUserCompanies();
            logged_user = getLoggedUserFromToken();
            // Fallback se non è presente nell'URL
        }

        //lasciare per vecchia login
        //companies = getUserCompanies();
        if (companies && companies.length > 0) {
            this.setState(
                {
                    companies,
                    selected_company: companies[0].id.toString()
                },
                () => {
                    if (
                        this.state.companies &&
                        this.state.companies.length === 1
                    ) {
                        this.saveCompany();
                    }
                }
            );
        }
        // Posso farmi passare il nome utente dal backend come ho fatto per companies
        // const logged_user = decodedUser; //getLoggedUserFromToken();
        if (!logged_user) {
            history.push("/login");
            authClient(aor.AUTH_LOGOUT);
        }
    }

    renderRadioGroup() {
        return (
            <FormControl style={{ width: 256 }}>
                <RadioGroup
                    name="select_company"
                    value={this.state.selected_company}
                    onChange={this.handleChange.bind(this)}
                >
                    {this.getCompanyComponents()}
                </RadioGroup>
            </FormControl>
        );
    }

    renderButton() {
        return (
            <Button
                color="primary"
                variant="contained"
                style={{
                    marginBottom: 10
                }}
                onClick={this.saveCompany.bind(this)}
            >
                <Done />
                <TranslatedText resource_name="resources.companies.actions.selectCompany" />
            </Button>
        );
    }

    render() {
        if (
            this.state.companies &&
            this.state.companies.length === 1 &&
            this.state.selected_company
        ) {
            return null;
        } else {
            return (
                <Card>
                    <aor.ViewTitle
                        title={
                            <TranslatedText resource_name="resources.companies.actions.selectLoginCompany" />
                        }
                    />
                    <div style={{ marginLeft: 10 }}>
                        {this.state.companies ? (
                            <div>
                                {this.renderRadioGroup()}
                                <br />
                                <Divider />
                                <br />
                                {this.renderButton()}
                            </div>
                        ) : null}
                    </div>
                </Card>
            );
        }
    }
}

export default SelectCompany;



// WEBPACK FOOTER //
// ./src/components/SelectCompany.js